import { useEffect, useRef, useState } from "react";
import "./index.css";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import { globalTextFormat } from "../../../../../utils/globalTextFormat";
import DynamicAdditionalFields from "../../../../_utils/TransactionCommonComponents/DynamicAdditionalFields";
import globalText from "../../../../../utils/globalText";

const ScheduleTransactionStepAdditionalDetails = (props) => {
  const dateRef = useRef(null);
  const dropdownRefs = useRef(null);
  const [dropdowns, setDropdowns] = useState({});

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleInputChange = (e) => {
    if (e?.preventDefault) e.preventDefault();

    const name = e?.target?.name ?? e?.name;
    const value = e?.target?.value ?? e?.value;

    const field =
      props?.txnPayLoad?.selectedCategory?.configuration?.data?.find(
        (f) => f.name === name,
      );

    if (!field) return;

    let updatedData = { ...props.additionalData };

    switch (field.data_type) {
      case "month_year": {
        if (value?.month && value?.year) {
          const monthNumber = (
            months.indexOf(value.month) + GlobalConfiguration?.lengthCheckOne
          )
            .toString()
            .padStart(2, "0");
          updatedData[name] = `${monthNumber}/${value.year}`;
        }
        break;
      }

      case "from_year_to_year": {
        updatedData[name] = {
          from:
            value?.from !== undefined && value?.from !== ""
              ? Number(value.from)
              : null,
          to:
            value?.to !== undefined && value?.to !== ""
              ? Number(value.to)
              : null,
        };
        break;
      }

      case "date_range": {
        if (value?.start_date && value?.end_date) {
          updatedData[name] = {
            start_date: value.start_date,
            end_date: value.end_date,
          };
        }
        break;
      }

      case "numeric": {
        const cleaned = String(value)
          .replace(/\D/g, "")
          .slice(
            GlobalConfiguration?.lengthCheckZero,
            GlobalConfiguration?.gstLength,
          );

        updatedData[name] = cleaned;
        break;
      }

      default: {
        updatedData[name] = value;
      }
    }
    props.setAdditionalData(updatedData);
  };
  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        props?.setShowDatePickerCal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!props?.additionalData) return;

    const storeData =
      props.txnPayLoad.selectedCategory?.configuration?.data?.map((val) => {
        const dataValue = props.additionalData[val?.name];

        if (
          dataValue !== undefined &&
          (Array.isArray(dataValue)
            ? dataValue.length > GlobalConfiguration?.lengthCheckZero
            : dataValue !== "")
        ) {
          if (val?.data_type === "numeric") {
            const intVal = parseInt(
              dataValue,
              GlobalConfiguration?.searchHeight,
            );
            return isNaN(intVal) ? val : { ...val, value: intVal };
          }

          return { ...val, value: dataValue };
        }

        switch (val?.data_type) {
          case "multi_select_list":
            return { ...val, value: [] };

          case "toggle":
            return { ...val, value: false };

          case "hyperlink":
          case "upload":
            return { ...val, value: "" };

          default:
            return val?.mandatory !== "Y" ? { ...val, value: "" } : val;
        }
      });

    props.setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
  }, [props?.additionalData, props?.txnPayLoad.selectedCategory]);

  return (
    <>
      <div className="w-width-full scheduleHide-scroll-bar Qmd:pt-padding-lg py-padding-md flex flex-col lg:flex-row Qmd:gap-gap-xl px-padding-md lg:px-padding-base h-height-full">
        <div className="global-card-create w-full Qmd:w-full lg:w-width-md p-padding-md flex flex-col items-start h-[max-content]">
          <div className="text-text-primary font-semibold text-font-md flex flex-row justify-between">
            <p className="text-center">
              {globalTextFormat(globalText?.ADDITIONAL_DETAILS, [
                GlobalConfiguration?.lengthCheckZero,
                GlobalConfiguration?.lengthCheckOne,
              ])}
            </p>
          </div>
          <div className="w-full flex flex-col gap-gap-md pt-padding-md">
            <DynamicAdditionalFields
              mergeCategory={props?.txnPayLoad?.mergeCategory}
              additionalData={props?.additionalData}
              setAdditionalData={props?.setAdditionalData}
              hyperLink={props?.hyperLinks}
              setHyperLink={props?.setHyperLinks}
              timeData={props?.timeData}
              setTimeData={props?.setTimeData}
              quantities={props?.quantities}
              setQuantities={props?.setQuantities}
              uploadedFiles={props?.uploadedFiles}
              setUploadedFiles={props?.setUploadedFiles}
              startDate={props?.startDate}
              endDate={props?.endDate}
              setStartDate={props?.setStartDate}
              setEndDate={props?.setEndDate}
              selectedValue={props?.selectedValue}
              setSelectedValue={props?.setSelectedValue}
              selectedValueMonth={props?.selectedValueMonth}
              setSelectedValueMonth={props?.setSelectedValueMonth}
              initialRefactorAdditionalDetail={
                props?.initialRefactorAdditionalDetail
              }
              setInitialRefactorAdditionalDetail={
                props?.setInitialRefactorAdditionalDetail
              }
              previewImages={props?.previewImages}
              setPreviewImages={props?.setPreviewImages}
              onInputChanged={(name, value, type) => {
                handleInputChange({
                  target: {
                    name,
                    value,
                    data_typeChan: type,
                  },
                });
              }}
            />
          </div>
        </div>
        <div className="w-width-full Qmd:w-width-md flex-shrink-0 Qmd:block hidden"></div>
      </div>
    </>
  );
};

export default ScheduleTransactionStepAdditionalDetails;
